import action from 'app/lib/action';
import {FLASH_MESSAGE} from '../constants/actionTypes';

export default {
    set: (id, messageIds, titleId, theme, ttl, params) => action(FLASH_MESSAGE.SET)({id, messageIds, titleId, theme, ttl, params}),
    remove: (id) => action(FLASH_MESSAGE.REMOVE)({id})
};
